import operations from '~/helpers/device-operations';
import { Operation } from '~/interfaces/device.interface';
import { NAPlug } from '~/models/gateways/netatmo/NAPlug.model';

export class NTG extends NAPlug {

    get deviceOperations(): Operation[]  {
        return super.deviceOperations.concat([
            operations.modelDump({ callback: this.modelDump }),
        ]);
    }

    get fieldFwPrivate() {
        return undefined;
    }

    get fieldRelayConnected() {
        return undefined;
    }

}
